import { addendumFile } from '../../actionTypes';

export default function addendumFileList(state = {}, action) {
  switch (action.type) {
    case addendumFile.downloadByFormBuilderFieldId.start:
    case addendumFile.download.start:
      return {
        ...state,
        loading: true,
      };
    case addendumFile.downloadByFormBuilderFieldId.end:
    case addendumFile.download.end:
      return {
        ...state,
        loading: false,
      };
    case addendumFile.downloadByFormBuilderFieldId.error:
    case addendumFile.download.error:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
